var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "start-page-event ci-card" },
    [
      _c("div", { staticClass: "d-flex flex-row" }, [
        _c("div", { staticClass: "flex-column flex-grow-1" }, [
          _c("h2", {
            staticClass: "h2",
            domProps: {
              textContent: _vm._s(_vm.$t("ui.components.start.event.title")),
            },
          }),
          _vm._v(" "),
          _c("p", {
            staticClass: "text-muted",
            domProps: {
              textContent: _vm._s(
                _vm.$t("ui.components.start.event.description")
              ),
            },
          }),
        ]),
        _vm._v(" "),
        !_vm.loading && _setup.props.event
          ? _c(
              "div",
              { staticClass: "d-none d-md-block d-xl-none" },
              [
                _c(_setup.CiButton, {
                  attrs: {
                    variant: "filled-primary",
                    label: _vm.$t("ui.components.start.event.button"),
                    to: { name: _vm.$routes.EVENTS_INDEX },
                  },
                  nativeOn: {
                    click: function ($event) {
                      return _setup.emit("tracking-click", {
                        targetName: "ButtonAllEvents",
                        sourceName: "Events",
                      })
                    },
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.loading
        ? [_vm._m(0)]
        : [
            _setup.props.event
              ? [
                  _c(_setup.CiSocialEventTile, {
                    attrs: {
                      "data-event": _setup.props.event,
                      "with-border": true,
                      variant: "start_page",
                      "additional-tracking": { sourceName: "StartPageEvents" },
                    },
                    on: { "tracking-click": _setup.propagateTrackClick },
                  }),
                ]
              : [_c(_setup.EventsEmptyState)],
          ],
      _vm._v(" "),
      !_vm.loading && _setup.props.event
        ? _c(
            "div",
            { staticClass: "d-md-none d-xl-block mt-3" },
            [
              _c(_setup.CiButton, {
                staticClass: "w-100",
                attrs: {
                  variant: "filled-primary",
                  label: _vm.$t("ui.components.start.event.button"),
                  to: { name: _vm.$routes.EVENTS_INDEX },
                },
                nativeOn: {
                  click: function ($event) {
                    return _setup.emit("tracking-click", {
                      targetName: "ButtonAllEvents",
                      sourceName: "Events",
                    })
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "loading-spinner d-flex flex-column" }, [
      _c("div", {
        staticClass:
          "d-flex justify-content-center mdi mdi-loading mdi-spin h1 my-auto",
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }